import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-privacy-policy-th',
  templateUrl: './privacy-policy-th.component.html',
  styleUrls: ['./privacy-policy-th.component.scss']
})
export class PrivacyPolicyThComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
